//import { Configuration } from 'msal';

//export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

// #region 1) B2C policies and user flows
/**
 * Enter here the user flows and custom policies for your B2C application, STAGING
 */
export const b2cPolicies = {
  authorityDomain:"stgibgca.b2clogin.com",
  names: {
      signUpSignIn: "b2c_1a_ibgca_iam_emailid_susi",
      resetPassword: "b2c_1a_ibgca_iam_emailid_passwordreset",
      editProfile: "b2c_1a_ibgca_iam_emailid_profileedit",
      Custom_Login : "B2C_1A_IBGCA_IAM_CUSTOMLOGIN_EMAILID_SUSI"

  },
  authorities: {
      signUpSignIn: {
          authority: "https://stgibgca.b2clogin.com/stgibgca.onmicrosoft.com/b2c_1a_ibgca_iam_emailid_susi",
      },
      resetPassword: {
          authority: "https://stgibgca.b2clogin.com/stgibgca.onmicrosoft.com/b2c_1a_ibgca_iam_emailid_passwordreset",
      },
      editProfile: {
          authority: "https://stgibgca.b2clogin.com/stgibgca.onmicrosoft.com/b2c_1a_ibgca_iam_emailid_profileedit"
      },
      Custom_Login: {
        authority: "https://stgibgca.b2clogin.com/stgibgca.onmicrosoft.com/B2C_1A_IBGCA_IAM_CUSTOMLOGIN_EMAILID_SUSI"
    }
  }

};


// #endregion


// #region 2) Web API Configuration
/**
* Enter here the coordinates of your Web API and scopes for access token request
* The current application coordinates were pre-registered in a B2C tenant.
*/
export const apiConfig: {scopes: string[]; webApi: string} = {
  scopes: ['https://stgibgca.onmicrosoft.com/iBGCA.IAM.API/ibgca.api.read'],
  webApi: 'https://api-stg.mybgca.net'
};
// #endregion



// #region 3) Authentication Configuration
/**
* Config object to be passed to Msal on creation. For a full list of msal.js configuration parameters,
* visit https://azuread.github.io/microsoft-authentication-library-for-js/docs/msal/modules/_configuration_.html
*/
export const msalConfig = {
  auth: {
      clientId: 'e08fe527-258d-4306-aa22-cd015d8771dc',
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri: 'https://stage.mybgca.net',
      postLogoutRedirectUri: 'https://stage.mybgca.net/sign-out.html',
      navigateToLoginRequestUrl: true,
      validateAuthority: false,
    },
  cache: {
      cacheLocation: 'sessionStorage'
  },
};

export const environment = {
  production: false,
  apiHost: apiConfig.webApi
};
export const myBGCAppId = {
  clientId: '1601b0a7-63e5-45c7-9fa2-982f65541b2d',
  applicationId: 'c3ea144a-f663-4a97-8044-2e140aa5f469'
}